const d = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTd2Mkgydi0yaDIwem0wLTZ2Mkgydi0yaDIwem0wLTZ2MkgyVjVoMjB6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  d as default
};
//# sourceMappingURL=hamburger-4a6e9e82.mjs.map
